export const UPDATE_ASPERA_STATUS = 'UPDATE_ASPERA_STATUS'
export const UPDATE_ASPERA_TRANSFER = 'UPDATE_ASPERA_TRANSFER'
